import { useState } from "react";
import {
    FiHelpCircle,
    FiMenu,
    FiX
} from "react-icons/fi";
import {
    MdOutlineAccountCircle,
    MdOutlineAssessment,
    MdOutlineDashboard,
    MdOutlineEventAvailable,
} from "react-icons/md";
import { RiBillLine } from "react-icons/ri";
import { useLocation } from "react-router-dom";
import Logo from "../../../../assets/logos/newLogo.png";
type DoctorDashboardSideBarProps = {
  activeTab: string;
  handleTabClick: (path: string) => void;
};

const DoctorDashboardSideBar = (Props: DoctorDashboardSideBarProps) => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    { label: "Dashboard", path: "dashboard", icon: MdOutlineDashboard },
    {
      label: "Availability",
      path: "availability",
      icon: MdOutlineEventAvailable,
    },
    { label: "Assessment", path: "assessment", icon: MdOutlineAssessment },
    { label: "Billing", path: "billing", icon: RiBillLine },
    { label: "Account", path: "profile", icon: MdOutlineAccountCircle },
  ];

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const handleTabClick = (path: string) => {
    toggleSidebar();
    Props.handleTabClick(path);
  };

  console.log("location.pathname =>", location.pathname);

  return (
    <div className="relative">
      <div className="md:hidden px-6 pt-2 w-screen flex ">
        <button className="text-gray-700" onClick={toggleSidebar}>
          {isOpen ? (
            <FiX className="w-6 h-6" />
          ) : (
            <FiMenu className="w-6 h-6" />
          )}
        </button>
        <img
          src={Logo}
          width={"40%"}
          className="m-auto object-cover"
          alt="Logo"
        />
      </div>
      <div
        className={`fixed inset-y-0 left-0 w-72 md:w-full z-50 h-screen bg-white shadow-lg overflow-hidden transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out md:relative md:translate-x-0`}
      >
        <div className="p-4">
          <button className="text-gray-700 md:hidden" onClick={toggleSidebar}>
            {isOpen ? (
              <FiX className="w-6 h-6" />
            ) : (
              <FiMenu className="w-6 h-6" />
            )}
          </button>
          <div className="w-full py-2 items-center justify-center">
            <img src={Logo} width={80} className="m-auto w-1/2" alt="Logo" />
          </div>
          <div className="border-t border-gray-300 my-6"></div>
          <ul className="space-y-4">
            {menuItems.map((item) => (
              <li key={item.path} onClick={() => handleTabClick(item.path)}>
                <div
                  className={`flex items-center p-2  hover:bg-slate-800 hover:text-gray-200 rounded-md ${
                    Props.activeTab === item.path
                      ? "bg-primary text-white"
                      : "text-grey-800"
                  }`}
                >
                  <item.icon className="w-5 h-5 mr-2" />
                  {item.label}
                </div>
              </li>
            ))}
            <li>
              <a
                href="/contactus"
                target="_blank"
                className={`flex items-center p-2  hover:bg-slate-800 hover:text-gray-200 rounded-md ${"text-grey-800"}`}
              >
                <FiHelpCircle className="w-5 h-5 mr-2" />
                {"Contact Us"}
              </a>
            </li>
          </ul>
        </div>
      </div>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black opacity-50 md:hidden"
          onClick={toggleSidebar}
        ></div>
      )}
    </div>
  );
};

export default DoctorDashboardSideBar;
